import { Box, Card, Modal } from "@mui/material";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import TagManager from "react-gtm-module";
import { IoCopyOutline } from "react-icons/io5";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import {
  GEOLOCATION_URL,
  RECAPTCHA_SITE_KEY,
  WEB_URL,
} from "../../src/constant/appConstants";
import fetcher from "../../src/dataProvider";
import { setUserDetail } from "../../src/redux/actions";
import { setUserData } from "../../src/redux/slices/user";
import eventBus from "../../util/eventBus";
import { songPageGTMCTAClick } from "../../util/gtmutil";
import StaticOutlineButton from "../Buttons/StaticOutlineBtn";
import auth from "../Layout/util/auth";
import SocialShareComponent from "../Buttons/socialShareReferral";
const recaptchaRef = React.createRef();

const useStyles = makeStyles((theme) => ({
  fan__referSection: {
    "@media (max-width:767px)": {
      padding: "30px 0",
    },
  },
  fanRefer__Details: {
    maxWidth: "1262px",
    margin: "auto",
  },

  fan__Refercode_details: {
    background: "linear-gradient(123.76deg, #DAE2F8 -5.66%, #D6A4A4 110.1%)",
    borderRadius: "30px",
    padding: "75px 0 35px 75px",
    position: "relative",
    maxWidth: "1000px",
    margin: "auto",
    "@media (max-width:767px)": {
      padding: "20px",
    },
    "& h3": {
      fontSize: "30px",
      color: "#120F2A",
      fontWeight: "800",
      "& span": {
        fontWeight: "600",
      },
      "@media (max-width:767px)": {
        fontSize: "18px",
      },
    },
    "& .Refercode": {
      padding: "5px 8px",
      color: "#000000",
      fontSize: "18px",
      boxShadow: "none",
      border: "1px dashed #000000",
      borderRadius: "6px",
      fontWeight: "500",
      marginTop: "35px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      "& span": {
        background: "#e7e7e7",
        display: "inline-block",
        padding: "6px 6px",
        color: "#000000",
        borderRadius: "5px",
        "& img": {
          width: "22px",
        },
      },
      "@media (max-width:767px)": {
        fontSize: "10px",
        marginTop: "20px",
        padding: "10px 7px",
      },
    },

    "& .Refercode__buttonFan": {
      transition: "all 0.5s ease",
      border: "2px solid #000",
      fontSize: "16px",
      fontWeight: "700 !important",
      color: "#fff",
      width: "198px",
      height: "60px",
      borderRadius: "100px",
      display: "inline-block",
      backgroundColor: "transparent",
      color: "#000",
      marginTop: "25px",
      cursor: "pointer",
      "@media (max-width:767px)": {
        width: "145px",
        height: "45px",
        padding: "12px 0",
        fontSize: "12px",
        marginTop: "20px",
      },
      "&:hover": {
        backgroundImage:
          "linear-gradient(to right, #E14084 0%, #3454FA 53.16%, #54B5BB 100%)",
        boxShadow: "0px 0px 31px 3px #3659f6",
        border: "none",
        color: "#fff",
      },
    },
    "& .fan__LeftSide": {
      width: "395px",
      "@media (max-width:767px)": {
        width: "195px",
      },
    },
    "& .coin__FanIcon": {
      "& .hand__fanIcon": {
        position: "absolute",
        right: "0",
        bottom: "-5px",
        "@media (max-width:767px)": {
          width: "153px",
          bottom: "90px",
        },
      },
      "& .Comp__fanIcon": {
        right: "200px",
        top: "45px",
        position: "absolute",
        bottom: "auto",
        "& img": {
          width: "200px",
        },
        "@media (max-width:767px)": {
          top: "29px",
          right: "13px",
          width: "134px",
        },
      },
      "& .Comp__fiat_money": {
        top: "-73px",
        right: "20px",
        bottom: "auto",
        position: "absolute",
        "@media (max-width:767px)": {
          top: "-37px",
          right: "-3px",
          width: "91px",
        },
      },
    },
  },
  ReferEarnFan__Heading: {
    display: "block",
    margin: "auto",
    textAlign: "center",
    marginBottom: "30px",
  },
  fan__ReferralIncentive: {
    padding: "35px 90px",
    "@media (max-width:767px)": {
      padding: "30px 30px 0",
    },
    "& h5": {
      fontSize: "20px",
      fontWeight: "800",
      color: "#fff",
      "@media (max-width:767px)": {
        fontSize: "18px",
        textAlign: "center",
      },
    },
    "& ul": {
      padding: "0",
      marginTop: "30px",
      listStyle: "none",
      "@media (max-width:767px)": {
        marginTop: "10px",
        marginBottom: "0px",
      },
      "& li": {
        fontSize: "16px",
        color: "#fff",
        padding: "0 10px 15px",
        "@media (max-width:767px)": {
          fontSize: "13px",
          padding: "15px 0 0",
        },
      },
    },
  },
  referral__signupsFan: {
    fontSize: "10px",
    color: "#0C091B",
    fontWeight: "600",
    marginTop: "25px !important",
    display: "block",
  },
  copied: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    linHeight: "17px",
    color: "#E14084",
    textAlign: "center",
  },
  sharerefcode_btn: {
    backgroundColor: "transparent",
  },
  reflinktext: {
    width: "100%",
    minWidth: "205px",
    overflow: "hidden",
    color: "#E14084",
    whiteSpace: "nowrap",
    "@media (max-width:480px)": {
      fontSize: "11px !important",
    },
  },
}));

const Refer = (props) => {
  const classes = useStyles();
  const r = auth();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [open2, setOpen2] = useState(false);
  const onCaptchaChange = (value) => {};
  const [user, setUser] = useState(auth);
  const [refLink, setRefLink] = useState(null);
  const [copied, setCopied] = useState(false);
  const [location, setLocation] = useState("");
  const { profile, id } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    getUserLocation();
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      let userId = localStorage.getItem("userId");
      if (isEmpty(userId)) {
        setRefLink("Please login to get referal link");
      } else {
        setIsLoggedIn(true);
        getProfile(userId);
      }
    }
  }, [r?.userId]);

  const { mutate: getUserLocation } = useMutation(
    () => fetcher.get(GEOLOCATION_URL),
    {
      onSuccess: (result) => {
        setLocation(result);
      },
      onError: (error) => {
        setLocation({});
      },
    }
  );

  const { mutate: getProfile } = useMutation(
    (id) => fetcher.get(`/v1/user/${profile?.id || id}`),
    {
      onSuccess: (response) => {
        dispatch(setUserData(response?.result));
        dispatch(
          setUserDetail({
            ...profile,
            referralId: response?.result?.referralId,
          })
        );
        setRefLink(`${WEB_URL}/?ic=${response?.result?.referralId?.refCode}`);
      },
      onError: (error) => {
        setNameUpdateError(true);
      },
    }
  );

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 500);
    }
  }, [copied]);

  const copyToClipboard = () => {
    songPageGTMCTAClick(
      r,
      "ctaClicks",
      "refer and earn",
      "copy link",
      "loggedIn",
      "Guest",
      "Home Page"
    );

    navigator?.clipboard?.writeText(
      refLink +
        "\n" +
        "Get ₹50 cashback up to 10% on NFT purchase using my referral link | Invest in Songs and Own Music | Earn multifold returns \n"
    );
    setCopied(true);
    if (user?.token) {
      const tagManagerArgs = {
        dataLayer: {
          event: "refralLinkCopied",
          refLink: refLink,
          userStatus: "loggedIn",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } else {
      const tagManagerArgs = {
        dataLayer: {
          event: "refralLinkCopied",
          refLink: refLink,
          userStatus: "Guest",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  };

  const handleLogin = () => {
    songPageGTMCTAClick(
      r,
      "ctaClicks",
      "refer and earn",
      "share link",
      "loggedIn",
      "Guest",
      "Home Page"
    );

    eventBus.dispatch("openLoginModal", { function_name: "uniqueCommunity" });
  };

  const handleRefralLink = (e) => {
    songPageGTMCTAClick(
      r,
      "ctaClicks",
      "refer and earn",
      "share link",
      "loggedIn",
      "Guest",
      "Home Page"
    );
    if (user?.token) {
      const tagManagerArgs = {
        dataLayer: {
          event: "refralLinkModalopen",
          refLink: refLink,
          userStatus: "loggedIn",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    } else {
      const tagManagerArgs = {
        dataLayer: {
          event: "refralLinkModalopen",
          refLink: refLink,
          userStatus: "Guest",
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
    e?.stopPropagation();
    setOpen2(true);
  };

  return (
    <Box id="Refer">
      <section className={classes.fan__referSection}>
        <Container maxWidth="lg">
          <div className={classes.fanRefer__Details}>
            <Box className={classes.fan__workSection} sx={{ width: "100%" }}>
              <Grid
                direction="row"
                alignItems="center"
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                <Grid item md={12}>
                  <div className={classes.ReferEarnFan__Heading}>
                    <img src={"/images/newHome/alll.png"} alt="" />
                  </div>
                  <div className={classes.fan__Refercode_details}>
                    <div className="fan__LeftSide">
                      <Typography variant="h3">
                        <span>Get</span> ₹50 Referral Cashback <span>upto</span>{" "}
                        10% <span>on every NFT Purchase of your friend.</span>
                      </Typography>

                      <Card
                        className="Refercode"
                        onClick={copyToClipboard}
                        style={{ cursor: "pointer" }}
                      >
                        <Typography className={classes.reflinktext}>
                          {refLink}
                        </Typography>
                        <Box style={{ lineHeight: "0" }}>
                          {isLoggedIn ? (
                            <>
                              {copied ? (
                                <Typography
                                  variant="h5"
                                  className={classes.copied}
                                >
                                  Copied
                                </Typography>
                              ) : (
                                <IoCopyOutline size={24} color="#E14084" />
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </Box>
                      </Card>

                      {isLoggedIn && (
                        <button
                          className="Refercode__buttonFan"
                          onClick={(e) => handleRefralLink(e)}
                        >
                          Share Refereral Link
                        </button>
                      )}
                      {!isLoggedIn && (
                        <button
                          className="Refercode__buttonFan"
                          onClick={() => handleLogin()}
                        >
                          Share Refereral Link
                        </button>
                      )}
                    </div>
                    <Typography
                      variant="p"
                      className={classes.referral__signupsFan}
                    >
                      *A user can earn maximum upto 500 on referral purchases*
                    </Typography>
                    <div className="coin__FanIcon">
                      <div className="Comp__fiat_money">
                        <img src={"/images/newHome/fiat_money.svg"} alt="" />
                      </div>
                      <div className="Comp__fanIcon">
                        <img src={"/images/home/coin3dgif.gif"} alt="" />
                      </div>
                      <div className="hand__fanIcon">
                        <img src={"/images/home/3dhandmin2.png"} alt="" />
                      </div>
                    </div>
                  </div>
                  <div className={classes.fan__ReferralIncentive}>
                    <Typography variant="h5"> Referral Incentive</Typography>
                    <ul>
                      <li>
                        You will get 10% Referral Cashback upto ₹50 every time
                        on the first NFT purchase of your friends when they sign
                        up using your referral link. Your friend will also get
                        10% Cashback upto ₹50.
                      </li>
                      {/* <li>
                        You will also get 20% Referral Bonus every time on the
                        first NFT purchase of your friends when they sign up
                        using your referral link. Your friend will also get 20%
                        Cashback.
                      </li> */}
                    </ul>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </div>
        </Container>
      </section>

      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={RECAPTCHA_SITE_KEY}
        onChange={onCaptchaChange}
      />
      <Modal open={open2} onClick={() => setOpen2(false)}>
        <SocialShareComponent
          style={{ left: "50%", top: "55%" }}
          nftLink={refLink}
          tokenType="refralLink"
        />
      </Modal>
    </Box>
  );
};

export default Refer;
